<template>
  <md-snackbar
    :md-duration="Infinity"
    :md-active.sync="active"
    :md-persistent="true"
  >
    <span>{{ text }}</span>
    <md-button @click="clear" v-if="action" style="color: white;"
      >Okay</md-button
    >
  </md-snackbar>
</template>

<script>
import Vue from "vue";

const eventBus = new Vue();
export { eventBus as Notification };

export default {
  methods: {
    clear() {
      this.active = false;
      this.action = false;
      this.text = "";
    },
  },
  async mounted() {
    eventBus.$on("start", ({ text }) => {
      this.active = true;
      this.text = text;
    });

    eventBus.$on("done", ({ text }) => {
      this.active = true;
      this.action = true;
      this.text = text;
    });
  },
  data: () => ({
    active: false,
    action: false,
    text: "",
  }),
};
</script>
